const ONR_AB_EXPERIMENT = 'onr-cart-ab';
// types
import { CartItem } from 'shared/types/cart';
import { CartListElements, CartPageElement, CartPageLoadData } from './types';

// helpers
import { getEligibleVariantName } from 'shared/components/ExperimentV2/helpers';

// constant
const LOCAL_STORAGE_KEY = 'nykaa_show_onr';
const LOCAL_STORAGE_KEY_EDD = 'isEddV2Enabled';

export const setOnrKeyStorage = () => {
  const { isEligible = false } = getEligibleVariantName(ONR_AB_EXPERIMENT);
  try {
    if (window.sessionStorage === undefined) {
      return;
    }
    window.sessionStorage.setItem(LOCAL_STORAGE_KEY, isEligible ? 'true' : 'false');
  } catch (e) {
    /** DO NOTHING */
  }
};

export const getOnrKeyStorage = () => {
  try {
    if (window.sessionStorage === undefined) {
      return;
    }
    return window.sessionStorage.getItem(LOCAL_STORAGE_KEY) === 'true' || false;
  } catch (e) {
    return false;
  }
};

// is product partially available
export const isPartialOOS = (item: CartItem) => {
  if (item.quantity > 1) {
    if (item.availableQty < item.quantity) return true;
  }
  return false;
};

export const getCheckUnCheckCounter = (): number => {
  return parseInt(window.sessionStorage.getItem('checkUnCheckCounter') || '0', 10);
};

// push element to an array only if the element is valid
const pushIfValid = (arr: string[], element?: any) => {
  if (!element) return arr;

  arr.push(element);
  return arr;
};

const getListToString = (cartListElements: { [key: string]: string[] }) => {
  const transformData: { [key: string]: string } = {};

  Object.keys(cartListElements).forEach((listName: string) => {
    transformData[listName] = cartListElements[listName].join(',');
  });

  return transformData;
};

export const getCartPageLoadData = (cart: CartPageLoadData) => {
  try {
    const { items = [], isEligibleOfferNudge, unselectedItems = [] } = cart;

    const cartElements: CartPageElement = {
      cartOOSCount: 0,
      productWithOfferCount: 0,
      availableOffersCount: 0,
      cartPartialOOSCount: 0,
      cartInStockCount: 0,
      cartDiscountApplied: 0,
      cartProductCount: 0,
      cartSubTotalAmount: 0,
      cartTotalAmount: 0,
      cartTotalQty: 0,
      currency: '',
      pincode: '',
      rewardPointsApplied: 0,
      shippingCharges: 0,
      additionalDiscountApplied: 0,
      cartFinalPrice: 0,
      couponCodeApplied: '',
      isFomoTimerVisible: false,
      cartCouponDiscount: 0,
      isEligibleForSpeculationRule: false,
      isPopupShown: false,
      noOfOffersApplied: 0,
      checkboxEnabledOnCart: false,
      checkboxTotalCount: 0,
      checkboxSelectedCount: 0,
      checkboxUnselectedCount: 0,
      partial_checkout: false,
      salePriceLiveFlag: false,
    };

    const cartListElements: CartListElements = {
      brandNameList: [],
      productIdList: [],
      productNameList: [],
      variantProductIdList: [],
      productTypeList: [],
      categoryLevel1List: [],
      categoryLevel2List: [],
      categoryLevel3List: [],
      categoryLevel4List: [],
      cartAvailableOffers: [],
      cartAppliedOffers: [],
      cartProducts: [],
    };

    cartElements.cartDiscountApplied = cart?.cartTotal?.cartDiscount?.amount;
    cartElements.cartProductCount = cart?.itemCount;
    cartElements.cartSubTotalAmount = cart?.cartTotal?.subTotal?.amount;
    cartElements.cartTotalAmount = cart?.cartTotal?.totalMrp?.amount;
    cartElements.cartTotalQty = cart?.quantity;
    cartElements.currency = cart?.currencyCode;
    cartElements.pincode = cart?.pincode || cart?.address?.postcode;
    cartElements.rewardPointsApplied = cart?.rewardsDTO?.rewardsApplied;
    cartElements.shippingCharges = cart?.cartTotal?.shipping.amount;
    cartElements.additionalDiscountApplied = cart?.cartTotal?.ruleDiscountWithoutLabel?.amount;
    cartElements.cartFinalPrice = cart?.cartTotal?.grandTotal.amount;
    cartElements.couponCodeApplied = cart?.couponCode;
    cartElements.isFomoTimerVisible = cart?.isFomoTimerVisibleOncart;
    cartElements.isEligibleForSpeculationRule = cart?.isEligibleForSpeculationRule;
    cartElements.youPayCount = cart?.youPayCount;
    cartElements.eligibleFreeSamples = cart?.freeGiftsBannerData?.eligibleCount;
    cartElements.claimedFreeSamples = cart?.freeGiftsBannerData?.claimedCount;
    cartElements.cartCouponDiscount = cart?.cartTotal?.couponDiscount?.amount;
    cartElements.noOfOffersApplied = cart?.appliedOfferLabelDetails?.length || 0;
    cartElements.checkboxEnabledOnCart = cart?.isEligibleCartPartialCheckout;

    cartElements.checkboxSelectedCount = cart?.isEligibleCartPartialCheckout ? 0 : 'na';
    cartElements.checkboxUnselectedCount = cart?.isEligibleCartPartialCheckout ? 0 : 'na';

    cartElements.isPopupShown =
      isEligibleOfferNudge && cart?.cartTotal?.promotionalDiscount?.amount > 0;
    cartElements.partial_checkout = cart?.unselectedItems?.length == 0 ? false : true;
    if (cart?.shippingDataDTO?.convenienceChargesDTO) {
      cart.shippingDataDTO.convenienceChargesDTO.map((val) => {
        cartElements[val.analyticsKey] = val.amount;
      });
    }

    const totalItems = items;

    const n = totalItems.length || 10;
    const isOnSalePresentInTopN = totalItems?.slice(0, n).some(product => product?.onSale === true);
    cartElements.salePriceLiveFlag = totalItems.some(obj => obj.onSale === true);
    let isSpecialTagsPresent = false;
    const specialTagsNameList: string[] = [];

    totalItems.forEach((item) => {
      const appliedOffers = item.offerCommunication?.appliedOfferIds || [];
      const offers = item.offerCommunication?.availableOfferIds || [];
      const offersCount = offers.length;

      if (item?.specialTag && Object.keys(item?.specialTag).length > 0) {
        isSpecialTagsPresent = true;
        const tagType = item?.specialTag.type;
        tagType && specialTagsNameList.push(tagType);
      }

      // this is added to support for future, currently we are not getting this value
      const categories = item?.primary_categories_json_all || undefined;

      cartElements.availableOffersCount += offersCount;
      cartElements.productWithOfferCount += offersCount > 0 ? 1 : 0;
      cartElements.cartOOSCount += item.isOutOfStock ? 1 : 0;
      cartElements.cartPartialOOSCount += isPartialOOS(item) ? 1 : 0;
      cartElements.cartInStockCount += item.isOutOfStock || isPartialOOS(item) ? 0 : 1;
      if (cart?.isEligibleCartPartialCheckout) {
        cartElements.checkboxSelectedCount +=
          item.isOutOfStock || isPartialOOS(item) ? 0 : item?.selectedItemForCheckout ? 1 : 0;
        cartElements.checkboxTotalCount += item.isOutOfStock || isPartialOOS(item) ? 0 : 1;
      }
      cartListElements.brandNameList = pushIfValid(
        cartListElements.brandNameList,
        item?.brandNames[0]
      );
      cartListElements.productIdList.push(item.parentId);
      cartListElements.productNameList.push(item.name);
      cartListElements.variantProductIdList.push(item.productId);

      cartListElements.productTypeList = pushIfValid(
        cartListElements.productTypeList,
        item.productType
      );
      cartListElements.categoryLevel1List = pushIfValid(
        cartListElements.categoryLevel1List,
        categories?.l1_Category?.name
      );
      cartListElements.categoryLevel2List = pushIfValid(
        cartListElements.categoryLevel2List,
        categories?.l2_Category?.name
      );
      cartListElements.categoryLevel3List = pushIfValid(
        cartListElements.categoryLevel3List,
        categories?.l3_Category?.name
      );
      cartListElements.categoryLevel4List = pushIfValid(
        cartListElements.categoryLevel4List,
        categories?.l4_Category?.name
      );

      if (offersCount > 0) {
        const offerData = `${item.productId}:${offers.join('|')}`;
        cartListElements.cartAvailableOffers.push(offerData);
      }

      if (appliedOffers.length > 0) {
        const offerData = `${item.productId}:${appliedOffers.join('|')}`;
        cartListElements.cartAppliedOffers.push(offerData);
      }

      const productStockStatus = item.isOutOfStock
        ? 'OOS'
        : isPartialOOS(item)
          ? 'partialOOS'
          : 'instock';

      cartListElements.cartProducts.push({
        edd_o2d: item?.estimatedDeliveryTime,
        product_id: item?.parentId,
        product_name: item?.productTitle,
        product_type: item?.productType,
        mrp_price: item?.cartItemPriceDTO?.mrp,
        product_stock_status: productStockStatus,
        brand_name: item?.brandNames[0],
        discounted_percent: item?.cartItemPriceDTO?.catalogDiscountRate,
        discounted_price: item?.cartItemPriceDTO?.price,
        is_edd_present: item?.estimatedDeliveryTime ? true : false,
        quantity: item?.quantity,
        variant_product_id: item?.productId,
        variant_type: item?.packSize,
        is_checkbox_selected:
          productStockStatus === 'instock' ? item?.selectedItemForCheckout : false,
        is_price_participating_sku: item?.onSale === true ? true : false,
        ...(item?.onSale === true
          ? {
            is_price_participating_sku_list: (() => {
              switch (item?.tag) {
                case 1:
                  return 'MRP/DP';
                case 2:
                  return 'CART Rule';
                case 3:
                  return 'Both';
                default:
                  return '';
              }
            })()
          }
          : {})
      });
    });

    unselectedItems.forEach((item) => {
      const appliedOffers = item.offerCommunication?.appliedOfferIds || [];
      const offers = item.offerCommunication?.availableOfferIds || [];
      const offersCount = offers.length;

      // this is added to support for future, currently we are not getting this value
      const categories = item?.primary_categories_json_all || undefined;

      cartElements.availableOffersCount += offersCount;
      cartElements.productWithOfferCount += offersCount > 0 ? 1 : 0;
      cartElements.cartOOSCount += item.isOutOfStock ? 1 : 0;
      cartElements.cartPartialOOSCount += isPartialOOS(item) ? 1 : 0;
      cartElements.cartInStockCount += item.isOutOfStock || isPartialOOS(item) ? 0 : 1;
      if (cart?.isEligibleCartPartialCheckout) {
        cartElements.checkboxUnselectedCount += isPartialOOS(item) ? 0 : 1;
      }

      cartListElements.brandNameList = pushIfValid(
        cartListElements.brandNameList,
        item?.brandNames[0]
      );
      cartListElements.productIdList.push(item.parentId);
      cartListElements.productNameList.push(item.name);
      cartListElements.variantProductIdList.push(item.productId);

      cartListElements.productTypeList = pushIfValid(
        cartListElements.productTypeList,
        item.productType
      );
      cartListElements.categoryLevel1List = pushIfValid(
        cartListElements.categoryLevel1List,
        categories?.l1_Category?.name
      );
      cartListElements.categoryLevel2List = pushIfValid(
        cartListElements.categoryLevel2List,
        categories?.l2_Category?.name
      );
      cartListElements.categoryLevel3List = pushIfValid(
        cartListElements.categoryLevel3List,
        categories?.l3_Category?.name
      );
      cartListElements.categoryLevel4List = pushIfValid(
        cartListElements.categoryLevel4List,
        categories?.l4_Category?.name
      );

      if (offersCount > 0) {
        const offerData = `${item.productId}:${offers.join('|')}`;
        cartListElements.cartAvailableOffers.push(offerData);
      }

      if (appliedOffers.length > 0) {
        const offerData = `${item.productId}:${appliedOffers.join('|')}`;
        cartListElements.cartAppliedOffers.push(offerData);
      }

      if (cart?.isEligibleCartPartialCheckout) {
        cartElements.checkboxTotalCount += item.isOutOfStock || isPartialOOS(item) ? 0 : 1;
      }

      const productStockStatus = item.isOutOfStock
        ? 'OOS'
        : isPartialOOS(item)
          ? 'partialOOS'
          : 'instock';

      cartListElements.cartProducts.push({
        edd_o2d: item?.estimatedDeliveryTime,
        product_id: item?.parentId,
        product_name: item?.productTitle,
        product_type: item?.productType,
        mrp_price: item?.cartItemPriceDTO?.mrp,
        product_stock_status: productStockStatus,
        brand_name: item?.brandNames[0],
        discounted_percent: item?.cartItemPriceDTO?.catalogDiscountRate,
        discounted_price: item?.cartItemPriceDTO?.price,
        is_edd_present: item?.estimatedDeliveryTime ? true : false,
        quantity: item?.quantity,
        variant_product_id: item?.productId,
        variant_type: item?.packSize,
        is_checkbox_selected: false,
        is_price_participating_sku: item?.onSale === true ? true : false,
        ...(item?.onSale === true
          ? {
            is_price_participating_sku_list: (() => {
              switch (item?.tag) {
                case 1:
                  return 'MRP/DP';
                case 2:
                  return 'CART Rule';
                case 3:
                  return 'Both';
                default:
                  return '';
              }
            })()
          }
          : {})
      });
    });

    const { cartProducts, ...listElementsToStringify } = cartListElements;

    return {
      ...cartElements,
      cartProducts: cartProducts,
      checkboxCheckUnCheckCount: getCheckUnCheckCounter(),
      partialCheckingOutCart: totalItems.length > 0 && cart?.unselectedItems?.length > 0,
      offerMetaDetail: cart?.appliedOfferLabelDetails
        ? JSON.stringify(cart?.appliedOfferLabelDetails)
        : '[]',
      ...getListToString(listElementsToStringify),
      isOnSalePresentInTopN: isOnSalePresentInTopN,
      specialTagEnabled: isSpecialTagsPresent,
      ...(isSpecialTagsPresent ? { specialTagNamesList: specialTagsNameList.join(',') } : {})
    };
  } catch (err) {
    return {};
  }
};

export const setStorageEddVariant = (isEddV2Enabled = false) => {
  try {
    if (window.sessionStorage === undefined) {
      return;
    }
    window.sessionStorage.setItem(LOCAL_STORAGE_KEY_EDD, isEddV2Enabled ? 'true' : 'false');
  } catch (e) {
    /** DO NOTHING */
  }
};
